import { useRouteMatch, useLocation, NavLink } from "react-router-dom";
import {Nav} from '@deere/fuel-react/Nav';
import { useState } from 'react';
import HomeIcon from "@mui/icons-material/Home";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { Badge } from "@mui/material";
import { usePendingState } from "../notifications-component/PendingStateContext";
const TopNavbar = (props) => {
  const userType = props.userType;
  const { pendingEmpty } =  usePendingState();
  const location = useLocation();
  const { url } = useRouteMatch();
  const ediItAdmin = props.ediItAdmin;
  const ediCoordnatorAccess = props.ediCoordnatorAccess;
  const gtlSupportGroup = props.gtlSupport;
  const supplierAccess = props.supplierAccess;
  const stakeholderAccess = props.stakeholderAccess;
  let isDevl = process.env.REACT_APP_OKTA_SCOPE === "scs-dev";
  let navigationItems = [];

  if (ediItAdmin) {
    navigationItems = [
      {
        href: "https://jdsn.deere.com",
        label: "JDSN Home",
        startIcon: <HomeIcon />,
      },
      {
        to: `${url}/Landing`,
        label: "Home",
        selected: location.pathname === '/ediSelfServicePortal/Landing',
        component:NavLink,
      },
      {
        to: `${url}/ediTesting`,
        label: "Automated EDI Testing",
        selected: location.pathname === "/ediSelfServicePortal/ediTesting",
        component:NavLink,
      },
      {
        to: `${url}/labelAudit`,
        label: "Label Compliance",
        selected: location.pathname === "/ediSelfServicePortal/labelAudit",
        component:NavLink,
      },

      {
        to: `${url}/ediSetupDetails`,
        label: "EDI Setup Details",
        selected: location.pathname === "/ediSelfServicePortal/ediSetupDetails",
        component:NavLink,
      },
      /* NEW AS2 Direct Connect Menu */
      {
        label: "AS2 Direct Connect",
        subNav: [
          {
            to: `${url}/newAs2TradingRelationship`,
            label: "New AS2 Trading Relationship",
            selected:
              location.pathname ===
              "/ediSelfServicePortal/newAs2TradingRelationship",
              component:NavLink,
          },
          {
            to: `${url}/updateAs2Relationship`,
            label: "Update AS2 Relationship",
            selected:
              location.pathname ===
              "/ediSelfServicePortal/updateAs2Relationship",
              component:NavLink,
          },
          {
            to: `${url}/supplierUpdate`,
            label: "Supplier Update",
            selected: location.pathname === '/ediSelfServicePortal/supplierUpdate',
            component:NavLink,
        },
        ],
      },
      {
        label: "AS2 Reports",
        subNav: [
          {
            to: `${url}/as2CommunicationStatus`,
            label: "Communication Status",
            selected:
              location.pathname ===
              "/ediSelfServicePortal/as2CommunicationStatus",
              component:NavLink,
          },
          // {
          //     href: `${url}/as2TradingPartnerProfiles`,
          //     label: "Trading Partner - AS2 Connection Details",
          //     selected: location.pathname === '/ediSelfServicePortal/asTradingPartnerProfiles'
          // },
          // ,
          // {
          //     href: `${url}/as2TPMismatchCACerts`,
          //     label: "Trading Partners - CA Certs Mismatch",
          //     selected: location.pathname === '/ediSelfServicePortal/as2TPMismatchCACerts'
          // }
        ],
      },
      {
        to: `${url}/observability`,
        label: "Observability Dashboard",
        selected: location.pathname === "/ediSelfServicePortal/observability",
        component:NavLink,
      },

      {
        to: `${url}/admin`,
        label: "Admin",
        selected: location.pathname === "/ediSelfServicePortal/admin",
        component:NavLink,
      },
      {
        to: `${url}/Notifications`,
        label: "Notifications",
        selected: location.pathname === "/ediSelfServicePortal/Notifications",
        component:NavLink,
        endIcon: (
          <Badge  color="error" variant="dot" invisible={pendingEmpty}
          sx={{
            '& .MuiBadge-badge':{
              top:'8px',
              right:'8px'
            },
          }}>
          <NotificationsNoneIcon />
          </Badge>
        )
      }/* ,
      {
        to: `${url}/documentHistory`,
        label: "Document History",
        selected: location.pathname === "/ediSelfServicePortal/documentHistory",
        component:NavLink
      } */
    ];
  }

  if (ediCoordnatorAccess) {
    navigationItems = [
      {
        href: "https://jdsn.deere.com",
        label: "JDSN Home",
        startIcon: <HomeIcon />,
      },
      {
        to: `${url}/Landing`,
        label: "Home",
        selected: location.pathname === '/ediSelfServicePortal/Landing',
        component:NavLink,
      },
      {
        to: `${url}/ediTesting`,
        label: "Automated EDI Testing",
        selected: location.pathname === "/ediSelfServicePortal/ediTesting",
        component:NavLink,
      },
      {
        to: `${url}/labelAudit`,
        label: "Label Compliance",
        selected: location.pathname === "/ediSelfServicePortal/labelAudit",
        component:NavLink,
      },

      {
        to: `${url}/ediSetupDetails`,
        label: "EDI Setup Details",
        selected: location.pathname === "/ediSelfServicePortal/ediSetupDetails",
        component:NavLink,
      },
      /* NEW AS2 Direct Connect Menu */
      {
        label: "AS2 Direct Connect",
        subNav: [
          {
            to: `${url}/newAs2TradingRelationship`,
            label: "New AS2 Trading Relationship",
            selected:
              location.pathname ===
              "/ediSelfServicePortal/newAs2TradingRelationship",
              component:NavLink,
          },
          {
            to: `${url}/updateAs2Relationship`,
            label: "Update AS2 Relationship",
            selected:
              location.pathname ===
              "/ediSelfServicePortal/updateAs2Relationship",
              component:NavLink,
          },
          {
            to: `${url}/supplierUpdate`,
            label: "Supplier Update",
            selected: location.pathname === '/ediSelfServicePortal/supplierUpdate',
            component:NavLink,
        },
        ],
      },
      {
        label: "AS2 Reports",
        subNav: [
          {
            to: `${url}/as2CommunicationStatus`,
            label: "Communication Status",
            selected:
              location.pathname ===
              "/ediSelfServicePortal/as2CommunicationStatus",
              component:NavLink,
          },
          // {
          //     href: `${url}/as2TradingPartnerProfiles`,
          //     label: "Trading Partner - AS2 Connection Details",
          //     selected: location.pathname === '/ediSelfServicePortal/asTradingPartnerProfiles'
          // },
          // ,
          // {
          //     href: `${url}/as2TPMismatchCACerts`,
          //     label: "Trading Partners - CA Certs Mismatch",
          //     selected: location.pathname === '/ediSelfServicePortal/as2TPMismatchCACerts'
          // }
        ],
      },
      {
        to: `${url}/admin`,
        label: "Admin",
        selected: location.pathname === "/ediSelfServicePortal/admin",
        component:NavLink,
      },
      {
        to: `${url}/Notifications`,
        label: "Notifications",
        selected: location.pathname === "/ediSelfServicePortal/Notifications",
        component:NavLink,
        endIcon: (
          <Badge  color="error" variant="dot" invisible={pendingEmpty}
          sx={{
            '& .MuiBadge-badge':{
              top:'8px',
              right:'8px'
            },
          }}>
          <NotificationsNoneIcon />
          </Badge>
        )
      }
    ];
  }

  if (gtlSupportGroup) {
    navigationItems = [
      {
        href: "https://jdsn.deere.com",
        label: "JDSN Home",
        startIcon: <HomeIcon />,
      },
      {
        to: `${url}/Landing`,
        label: "Home",
        selected: location.pathname === '/ediSelfServicePortal/Landing',
        component:NavLink,
      },

      {
        to: `${url}/ediTesting`,
        label: "Automated EDI Testing",
        selected:
          location.pathname === "/ediSelfServicePortal/ediTesting"
            ? true
            : false,
            component:NavLink,
      },
      {
        to: `${url}/labelAudit`,
        label: "Label Compliance",
        selected:
          location.pathname === "/ediSelfServicePortal/labelAudit"
            ? true
            : false,
            component:NavLink,
      },
      {
        to: `${url}/ediSetupDetails`,
        label: "EDI Setup Details",
        selected: location.pathname === "/ediSelfServicePortal/ediSetupDetails"
            ? true
            : false,
          component:NavLink,
      }
    ];
  }

  if (stakeholderAccess) {
    navigationItems = [
      {
        href: "https://jdsn.deere.com",
        label: "JDSN Home",
        startIcon: <HomeIcon />,
      },
      {
        to: `${url}/Landing`,
        label: "Home",
        selected: location.pathname === '/ediSelfServicePortal/Landing',
        component:NavLink,
      },
      {
        to: `${url}/ediTesting`,
        label: "Automated EDI Testing",
        selected: location.pathname === "/ediSelfServicePortal/ediTesting",
        component:NavLink,
      },
      {
        to: `${url}/labelAudit`,
        label: "Label Compliance",
        selected: location.pathname === "/ediSelfServicePortal/labelAudit",
        component:NavLink,
      },
      {
        to: `${url}/ediSetupDetails`,
        label: "EDI Setup Details",
        selected:
          location.pathname === "/ediSelfServicePortal/ediSetupDetails"
            ? true
            : false,
            component:NavLink,
      }
    ];
  }

  if (supplierAccess) {
    navigationItems = [
      {
        href: "https://jdsn.deere.com",
        label: "JDSN Home",
        startIcon: <HomeIcon />,
      },
      {
        to: `${url}/Landing`,
        label: "Home",
        selected: location.pathname === '/ediSelfServicePortal/Landing',
        component:NavLink,
      },
      {
        to: `${url}/ediTesting`,
        label: "Automated EDI Testing",
        selected: location.pathname === "/ediSelfServicePortal/ediTesting",
        component:NavLink,
      },
      {
        to: `${url}/labelAudit`,
        label: "Label Compliance",
        selected: location.pathname === "/ediSelfServicePortal/labelAudit",
        component:NavLink,
      },
      {
        to: `${url}/Notifications`,
        label: "Notifications",
        selected: location.pathname === "/ediSelfServicePortal/Notifications",
        component:NavLink,
        endIcon: (
          <Badge  color="error" variant="dot" invisible={pendingEmpty}
          sx={{
            '& .MuiBadge-badge':{
              top:'8px',
              right:'8px'
            },
          }}>
          <NotificationsNoneIcon />
          </Badge>
        )
      }
    ];
  }

  navigationItems.push(
    {
      href: "https://jdsn.deere.com/wps/myportal/jdsn/JDSN/Applications",
      label: "JDSN Applications",
    },
    {
      label: "Help",
      subNav: [
        {
          href: "https://jdsn.deere.com/wps/myportal/jdsn/JDSN/EDI",
          label: "Guideline Documents",
        },
        {
          href: "https://jdsn-contact-us.deere.com/",
          label: "Contact Us",
        },
      ],
    }
  );

  return (
    <Nav
      style={{ width: "10%", borderRadius: ".2rem" }}
      items={navigationItems}
      variant="side"
    />
  );
};

export default TopNavbar;
